"use client";

import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import PublicShowService from "@/app/_services/PublicShowService";
import { isUuidRouteParam } from "@/app/_utils/publicProductUrl";

export default function LegacyTicketRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const go = async () => {
      if (!id) {
        navigate("/tickets", { replace: true });
        return;
      }
      try {
        const show = isUuidRouteParam(id)
          ? await PublicShowService.getShowById(id)
          : await PublicShowService.getShowBySlug(id);
        if (cancelled) return;
        const target = show?.slug ? `/products/${show.slug}` : `/products/${id}`;
        navigate(target, { replace: true });
      } catch {
        if (!cancelled) navigate("/tickets", { replace: true });
      }
    };

    go();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "40vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={36} />
    </Box>
  );
}
